// Foundation theme JS. Kept tiny and dependency-free.
// - exposes the reduced-motion flag to CSS/JS
// NOTE: --header-height is set from theme settings in snippets/theme-styles.liquid and is
// intentionally NOT re-measured here. The header is a fixed-height bar (matches the source
// 56px). The previous sync measured the header-GROUP (announcement bar + header) and fed
// that back into the header's own `height: var(--header-height)`, collapsing the bar.
(function () {
  var root = document.documentElement;

  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setReducedMotion() {
    root.dataset.reducedMotion = mq.matches ? 'true' : 'false';
  }
  setReducedMotion();
  if (mq.addEventListener) mq.addEventListener('change', setReducedMotion);
})();
